module.exports = __webpack_public_path__ + "img/img_bgFx.2e9e81d9.png";